<template>
    <div v-if="showTime">
        <div class="m-model-bg" ></div>
        <div class="rgt-m-model" >
            <div class="model-title-box">
                <div style="font-size:16px;padding-left:5px">选择日期</div>
                <i class="icon iconguanbi" @click="closeModel" style="font-size:17px;margin-right:15px"></i>
            </div>
            <div>
                <div class="search">
                    <div class="search-menu">
                        <div class="menu-time " :class="{'select':tabType=='0'}" @click="changeTabType(0)" data-type="0">
                            <span>今日</span>
                        </div>
                        <div class="menu-time " :class="{'select':tabType=='1'}" @click="changeTabType(1)" data-type="1">
                            <span>昨日</span>
                        </div>
                        <div class="menu-time " :class="{'select':tabType=='5'}" @click="changeTabType(5)" data-type="5">
                            <span>前日</span>
                        </div>
                    </div> 
                    <div class="search-menu">
                        <div class="menu-time" :class="{'select':tabType=='2'}" @click="changeTabType(2)" data-type="2">
                            <i class="icon iconbenzhou"></i><span decode="true">&nbsp;近一周</span>
                        </div>
                        <div class="menu-time" :class="{'select':tabType=='3'}" @click="changeTabType(3)" data-type="3">
                            <i class="icon iconmonth"></i><span decode="true">&nbsp;近一月</span>
                        </div>
                        <div class="menu-time" :class="{'select':tabType=='4'}" @click="changeTabType(4)" data-type="4">
                            <span>自定义</span>
                        </div>
                    </div>
                    <div class="search-filter" style="margin-top:10px">
                        <div class="search-val">
                            <div class="val-item" :class="{'filter-item':tabType=='4'}">
                                <mu-date-input v-if="tabType=='4'"  v-model="startTime"  full-width :min-date="new Date('2015-09-01')" :max-date="maxDate"></mu-date-input>
                                <span v-else>{{startTime}}</span>
                            </div>
                            <div class="val-line">至</div>
                            <div class="val-item" :class="{'filter-item':tabType=='4'}">
                                <mu-date-input v-if="tabType=='4'" v-model="endTime" full-width :max-date="maxDate"></mu-date-input>
                                <span v-else>{{endTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="position:fixed;bottom:0px;right:0px;width: calc(100% - 120px);display: flex;justify-content: flex-end;">
                    <div class="btn-group">
                        <div style="width:49%;display:flex;justify-content:center" @click="selsectData">
                        <div class="icon iconright"></div>
                        <div style="padding-left:10px;">确定</div>
                        </div>
                        <div style="width:1px;background:#ddd;height:15px;"></div>
                        <div style="width:49%;display:flex;justify-content:center" @click="closeModel">
                        <div class="icon iconfanhui1"></div>
                        <div style="padding-left:10px;">返回</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['type','typeText','st','et'],
    data() {
        return {
            showTime:false,
            tabType: '0',
            startTime:'',
            endTime:'',
        };
    },

    mounted() {
        
    },
    methods: {
        open(){
            this.tabType=this.type
            this.startTime=this.st?this.st:this.moment().format("YYYY-MM-DD")
            this.endTime=this.et?this.et:this.moment().format("YYYY-MM-DD")
            this.showTime=true;
        },
        changeTabType(type) {
            let startTime = this.moment().format("YYYY-MM-DD");
            let endTime = this.moment().format("YYYY-MM-DD");
            this.tabType=type
            if (type == '0') {
                startTime = this.moment().format("YYYY-MM-DD");
                endTime = this.moment().format("YYYY-MM-DD");
            } else if (type == '1') {
                startTime = this.moment().add(-1, 'days').format("YYYY-MM-DD");
                endTime = this.moment().add(-1, 'days').format("YYYY-MM-DD");
            } else if (type == '2') {
                startTime = this.moment().subtract(7, 'days').format("YYYY-MM-DD")
                endTime = this.moment().format("YYYY-MM-DD")
            } else if (type == '3') {
                endTime = this.moment().format("YYYY-MM-DD")
                startTime = this.moment().add(-1, 'months').format("YYYY-MM-DD")
            } else if (type == '4') {}
            else if (type == '5') {
              startTime = this.moment().add(-2, 'days').format("YYYY-MM-DD");
              endTime = this.moment().add(-2, 'days').format("YYYY-MM-DD");
            }
            this.startTime=startTime
            this.endTime=endTime
        },
        selsectData(){
            this.$emit("update:type",this.tabType)
            switch (this.tabType) {
                case '0':
                    this.$emit("update:typeText",'今日')
                    break;
                case '1':
                    this.$emit("update:typeText",'昨日')
                    break;
                case '2':
                    this.$emit("update:typeText",'近一周')
                    break;
                case '3':
                    this.$emit("update:typeText",'近一月')
                    break;
                case '4':
                    this.$emit("update:typeText",'自定义数据')
                    break;
                case '5':
                    this.$emit("update:typeText",'前日')
                    break;
                default:
                    break;
            }
            this.$emit("update:st",this.moment(this.startTime).format("YYYY-MM-DD"))
            this.$emit("update:et",this.moment(this.endTime).format("YYYY-MM-DD"))
            this.showTime=false
        },
        closeModel(){
            this.showTime=false
        },
    },
};
</script>

<style scoped>
    
.m-model-bg {
  position: fixed;
  width: calc(100%);
  height: 100vh;
  right: 0px;
  top: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  /* background-color: #fff; */
  padding: 0px;
  box-sizing: border-box;
  z-index: 101;
}

.rgt-m-model {
  position: fixed;
  width: calc(100% - 80px);
  right: 0px;
  top: 0px;
  height: 100vh;
  padding: 0px 5px;
  /* background-color: #F6F6F6; */
  background-color: #fff;
  box-sizing: border-box;
  z-index: 102;
}

.m-model .model-tl {
  display: flex;
  align-items: center;
}

.m-model .model-tl .tl-text {
  flex: 1;
  font-size: 15px;
}

.m-model .model-tl .tl-text span {
  padding-bottom: 2px;
  color: #FFF;
  border-bottom: 3px solid #ccc
}

.m-model .model-tl .tl-icon {
  flex: 1;
  text-align: right;
}

.m-model .model-tl .tl-icon span {
  font-size: 15px;
  color: #FFF
}

.m-model .good-btn {
  margin-top: 7px;
}

.m-model .good-btn button {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #FFF;
  width: 100%;
  background-color: #486ad8
}

.model-title-box {
  display: flex;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
  align-items: center;
  border-bottom: 1px solid #ddd;
  color: #888
}

.search {
  margin: 10px 10px;
  border-radius: 5px;
  /* padding:0px 36px 20px 36px; */
  background: #FFF;
}

.search-lst {
  display: flex;
  justify-content: space-between
}

.search-lst-tag {
  width: 48%;
  /* padding:20px 0; */
  height: 32px;
  line-height: 32px;
  padding-top: 7px;
  display: flex;
  border-bottom: 1px solid #eee
}

.lst-tag-vle {
  width: 100%;
  text-align: center;
  /* font-weight:700; */
  color: #666;
  font-size: 13px;
}

.lst-tag-vle .placeholder {
  color:#adadad;
  font-size:12px;
  text-align: left;
}

.search-btn-group {
  width: 100%;
  display: flex;
  border-radius: 4px;
  background: #777;
  display: flex;
  align-items: center;
  justify-content: space-between
}

.search-btn {
  color: #fff;
  display: flex;
  width: 49%;
  justify-content: center;
  font-size: 14px;
}

.search .search-menu {
  display: flex;
  flex-wrap: wrap;
}

.search .search-menu .select span {

  border-bottom: 2px solid #52B381;
}

.search .search-menu .menu-time {
  width: 33%;
  text-align: center;
  font-size: 14px;
  position: relative;
}

.search .search-menu .small {
  width: 16% !important;
}

.search .search-menu .middle {
  width: 20% !important;
}

.search .search-menu .menu-time::after {
  content: '';
  /*CSS伪类用法*/
  position: absolute;
  /*定位背景横线的位置*/
  top: 30%;
  right: 0px;
  background: #CCC;
  /*宽和高做出来的背景横线*/
  width: 1px;
  height: 14px;
}

.search .search-menu .menu-time:nth-child(3)::after {
  width: 0px;
}

.search .search-menu .menu-time span {
  display: inline-block;
  padding: 7px 0px;
}

.search-filter {
  display: flex;
  margin-bottom: 20px;
}

.search .search-val {
  display: flex;
  padding-top: 20px;
  align-items: center;
  padding: 0px 20px;
  box-sizing: border-box;
  width: 100%
}

.search .search-val .val-line {
  font-size: 12px;
  width: 20px;
  text-align: center;
}

.search .search-val .val-item {
  width: calc(50% - 20px);
  text-align: center;
  font-size: 14px;
}

.search .search-val .filter-item {
  /* background-color:#52B381; */
  border-bottom: 1px solid #52B381;
}

.search .val-more {
  width: 150px;
  text-align: center;
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search .search-val .val-item span {
  padding-bottom: 10px;
  /* border-bottom: 1px solid #ddd */
}

.search .search-no {
  display: flex;
}

.btn-group {
  display: flex;
  width: 400px;
  width: 80%;
  margin-left:10px;
  color: #fff;
  height: 44px;
  line-height: 44px;
  align-items: center;
  background:#4C37B6
}
</style>


// WEBPACK FOOTER //
// src/components/selectTime/index.vue